import { useIsFetching } from '@tanstack/react-query';
import { Trans, useTranslation } from 'react-i18next';
import { Glyphicon } from 'react-bootstrap';
import SectionHeader from 'components/sectionHeader/SectionHeader';
import Button from 'components/button/Button';
import PropertyEditActionWrapper from 'pages/property/common/PropertyEditActionWrapper';
import useOpenPropertyFeeModal from './modal/useOpenPropertyFeeModal';
import { PROPERTIES_FEES_BASE_QUERY_KEY } from './PropertyFeesAndTaxes.utils';

const PropertyFeesAndTaxesHeader = () => {
  const { openAddModal } = useOpenPropertyFeeModal();
  const { t } = useTranslation();
  const amountOfFeesAndTaxesQueries = useIsFetching({
    queryKey: [PROPERTIES_FEES_BASE_QUERY_KEY],
  });
  const isFetchingFeesAndTaxes = amountOfFeesAndTaxesQueries > 0;

  const handleNewItem = () => {
    openAddModal();
  };

  return (
    <SectionHeader
      id="property-fees-taxes"
      title={t('pageProperty.feesTaxesAndPolicies.propertyFeesAndTaxes.title')}
      tooltip={
        <Trans
          i18nKey="pageProperty.feesTaxesAndPolicies.propertyFeesAndTaxes.tooltip"
          components={{
            1: (
              // eslint-disable-next-line jsx-a11y/control-has-associated-label, jsx-a11y/anchor-has-content
              <a
                href="https://help.hostfully.com/en/articles/3586061-set-up-your-listing-fees-taxes-and-policies"
                target="_blank"
                rel="noreferrer"
              />
            ),
            2: (
              // eslint-disable-next-line jsx-a11y/control-has-associated-label, jsx-a11y/anchor-has-content
              <a
                href="https://help.hostfully.com/en/articles/6812445-create-a-pet-fee"
                target="_blank"
                rel="noreferrer"
              />
            ),
          }}
        />
      }
      buttons={
        <PropertyEditActionWrapper tooltipId="property-fees-taxes-button-tooltip">
          <Button
            bsStyle="primary"
            data-testid="property-fees-taxes-button"
            disabled={isFetchingFeesAndTaxes}
            onClick={handleNewItem}
          >
            <Glyphicon glyph="plus" />
            {t(
              'pageProperty.feesTaxesAndPolicies.propertyFeesAndTaxes.addItem',
            )}
          </Button>
        </PropertyEditActionWrapper>
      }
    />
  );
};

export default PropertyFeesAndTaxesHeader;
